import { useState } from "react";
import { IconCoins } from "@tabler/icons-react";
import styles from "./BuyCredits.module.css";
import BuyCreditsButton from "./BuyCreditsButton";
import type { StripePrice } from "../../models/stripePrice";
import Button from "../UI/Button";
import Text from "../UI/Text";
// @ts-expect-error pure js
import { currencyFormatter } from "../../api/Functions";
// @ts-expect-error pure js
import useStripePrices from "../../hooks/use-stripe-prices";
// @ts-expect-error pure js
import { ProductType } from "../../utils/constants/stripe";
// @ts-expect-error pure js
import useStripePayment from "../../hooks/use-stripe-payment.js";

interface CreditsAccount {
  credits: number;
}

interface BuyCreditsProps {
  account: CreditsAccount;
  refreshAccount: () => Promise<CreditsAccount>;
  buyCredit?: boolean;
  typeCredits?: string;
}

export default function BuyCredits({
  account,
  refreshAccount,
  buyCredit = false,
  typeCredits = ProductType.CREDITS,
}: BuyCreditsProps) {
  const { initiatePayment } = useStripePayment();
  const [isLoadingCredits, setIsLoadingCredits] = useState(false);
  const [buyCredits, setBuyCredits] = useState(buyCredit);
  const { prices } = useStripePrices(typeCredits) as { prices: StripePrice[] };

  function initiatePaymentHandler(priceId: string) {
    initiatePayment(priceId, {
      onPaymentSuccessful: refreshCredits,
    });
  }

  async function refreshCredits(tryNb = 0) {
    setIsLoadingCredits(true);
    setBuyCredits(false);
    const currentCredits = account.credits;
    try {
      const account = await refreshAccount();
      const newCredits = account.credits;
      if (newCredits === currentCredits && tryNb < 20) {
        setTimeout(() => refreshCredits(tryNb + 1), 1000);
        return;
      }
      setIsLoadingCredits(false);
      if (tryNb >= 20) {
        console.error("Processing payment took longer than expected");
      }
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.banner}>
        <IconCoins size={28} stroke={1.5} className={styles.bannerIcon} />
        <div>
          <Text>Vos crédits</Text>
          <Text variant="kilo" weight="bold" color="primary">
            {currencyFormatter(account.credits / 100, { withSign: true })}
          </Text>
        </div>
        <Button
          type="button"
          variant="tertiary"
          className={styles.bannerAction}
          isLoading={isLoadingCredits}
          disabled={isLoadingCredits}
          onClick={() => setBuyCredits((prevState) => !prevState)}
        >
          {isLoadingCredits
            ? "Paiement en cours de traitement"
            : "Acheter des crédits"}
        </Button>
      </div>
      {buyCredits && (
        <div className={styles.grid}>
          {[...prices]
            .sort((p1, p2) => p1.unit_amount - p2.unit_amount)
            .map((price) => (
              <BuyCreditsButton
                onClick={initiatePaymentHandler}
                price={price}
                key={price.id}
                typeCredits={typeCredits}
              />
            ))}
        </div>
      )}
    </div>
  );
}
